import React from 'react';
import PropTypes from 'prop-types';
import { withStyles,styled } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%'
  },
  textField: {
    flexBasis: 200,
    color:'black'
  },
});
const CssTextField = styled(TextField)({
  "& .MuiInputBase-input":{
    color:'black',width:'100%',
    backgroundColor: '#F2F2F2',
    borderRadius:5
      
  },
  '& label.Mui-focused': {
    color: '#88213a',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#88213a',
     color:'#88213a'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
    
    },
    '&:hover fieldset': {
      borderColor: '#88213a',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#88213a',
    },
  },
});

class OutlinedInputAdornments extends React.Component {
  state = {
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  render() {

    return (
      <div style={{width: '100%',backgroundColor:'#c9c7c7',borderRadius:5}}>
        
        <CssTextField 
          id="outlined-adornment-password"
          style={{width: '100%',
          
          color:'#88213a',}}
          color="secondary"
          disable
          variant='filled'
          type={this.state.showPassword ? 'text' : 'password'}
          label="Contraseña"
          {... this.props}
          InputLabelProps={{
            style: {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
              color: '#88213a'
            } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  style={{color:'white'}}
                 
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  }
}

OutlinedInputAdornments.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string
};

export default withStyles(styles)(OutlinedInputAdornments);